import { render, staticRenderFns } from "./AGCCheckboxGroup.vue?vue&type=template&id=ba87b586&scoped=true&"
import script from "./AGCCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./AGCCheckboxGroup.vue?vue&type=script&lang=js&"
import style0 from "./AGCCheckboxGroup.vue?vue&type=style&index=0&id=ba87b586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba87b586",
  null
  
)

export default component.exports